export const CUSTOMER_STATUS = {
  NEUKUNDE: 'Neukunde',
  BESTANDSKUNDE: 'Bestandskunde'
}

export const BEDMAT_SKU = '9901395'
